// extracted by mini-css-extract-plugin
module.exports = {"cellWrapper":"style_cellWrapper__UgLNb","cellContentWrapper":"style_cellContentWrapper__2fOot","alignedCellsWrapper":"style_alignedCellsWrapper__3tug9"};